import { UPDATE_ADMIN_RECHARGE_REQUEST, UPDATE_ADMIN_RECHARGE_SUCCESS, UPDATE_ADMIN_RECHARGE_FAILURE, UPDATE_ADMIN_RECHARGE_RESET, } from "../../actions";
const initialState = {
    updateData: {},
    isLoading: false,
    error: null,
};
const UpdateAdminRechargereducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ADMIN_RECHARGE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case UPDATE_ADMIN_RECHARGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateData: action.payload, isLoading: false, error: null });
        case UPDATE_ADMIN_RECHARGE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case UPDATE_ADMIN_RECHARGE_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, updateData: null, error: null });
        default:
            return state;
    }
};
export default UpdateAdminRechargereducer;
